import { getColModelItem } from '../../../../services/lib/utils/helpers'
import React from 'react'
import { InputNumber } from 'antd'

export default class PalletStackingManagementColumnModel {
	static PalletStackingManagementColumn = [
	  {
		  title: 'Name',
		  align: 'left',
		  field: 'palletStackingName',
		  headerStyle: {
			  whiteSpace: 'nowrap',
			  paddingRight: '16px'
		  }
	  },
		{
			title: 'Ctns/Level',
			align: 'left',
			type: 'numeric',
			field: 'ctnsPerLevel',
			headerStyle: {
				whiteSpace: 'nowrap',
				paddingRight: '16px'
			},
			editComponent: (props: any) => {
				const handleChange = (value: any) => {
					const newCtnsPerLevel = value || 0
					const level = props.rowData.level || 0
					const addOnQty = props.rowData.addOnQty || 0
					const calculatedQuantity = newCtnsPerLevel * level + addOnQty
					props.onRowDataChange({
						...props.rowData,
						ctnsPerLevel: newCtnsPerLevel,
						quantity: calculatedQuantity
					})
				}
				return (
					<InputNumber
						value={props.rowData.ctnsPerLevel}
						onChange={handleChange}
						style={{ width: '100%' }}
						min={0}
					/>
				)
			}
		},
		{
			title: 'Level',
			align: 'left',
			type: 'numeric',
			field: 'level',
			headerStyle: {
				whiteSpace: 'nowrap',
				paddingRight: '16px'
			},
			editComponent: (props: any) => {
				const handleChange = (value: any) => {
					const newLevel = value || 0
					const ctnsPerLevel = props.rowData.ctnsPerLevel || 0
					const addOnQty = props.rowData.addOnQty || 0
					const calculatedQuantity = ctnsPerLevel * newLevel + addOnQty
					props.onRowDataChange({
						...props.rowData,
						level: newLevel,
						quantity: calculatedQuantity
					})
				}
				return (
					<InputNumber
						value={props.rowData.level}
						onChange={handleChange}
						style={{ width: '100%' }}
						min={0}
					/>
				)
			}
		},
		{
			title: 'Add On Qty',
			align: 'left',
			type: 'numeric',
			field: 'addOnQty',
			headerStyle: {
				whiteSpace: 'nowrap',
				paddingRight: '16px'
			},
			editComponent: (props: any) => {
				const handleChange = (value: any) => {
					const newAddOnQty = value || 0
					const ctnsPerLevel = props.rowData.ctnsPerLevel || 0
					const level = props.rowData.level || 0
					const calculatedQuantity = ctnsPerLevel * level + newAddOnQty
					props.onRowDataChange({
						...props.rowData,
						addOnQty: newAddOnQty,
						quantity: calculatedQuantity
					})
				}
				return (
					<InputNumber
						value={props.rowData.addOnQty}
						onChange={handleChange}
						style={{ width: '100%' }}
						min={0}
					/>
				)
			}
		},
		{
			title: 'Qty',
			align: 'left',
			type: 'numeric',
			field: 'quantity',
			edit: 'never',
			editable: 'never',
			headerStyle: {
				whiteSpace: 'nowrap',
				paddingRight: '16px'
			}
		},
		{
			...getColModelItem({
				title: 'Img',
				field: 'layoutImage',
				keywords: [
					'layoutImage'
				]
			}, () => ([{key: 'layoutImage', label: 'Img', otherOptions: {type: 'image'}}]))
		}
	]
}
